// Data is localStorage-only. SSR would paint an empty tank before hydration.
export const ssr = false;
export const prerender = true;
